import { render } from "./MainLogo.vue?vue&type=template&id=67801cef&scoped=true"
const script = {}

import "./MainLogo.vue?vue&type=style&index=0&id=67801cef&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67801cef"]])

export default __exports__